import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const INACTIVITY_LIMIT = 30 * 60 * 1000; // 30 minutes in ms

const useInactivityLogout = (setUser) => {
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    if (setUser) setUser(null);
    navigate("/login");
  };

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(logout, INACTIVITY_LIMIT);
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (!token) return; // not logged in, do nothing

    // ── 1. Auto logout on tab/browser close ──────────────────────────
    const handleBeforeUnload = () => {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    // ── 2. Auto logout after 30 min inactivity ────────────────────────
    const activityEvents = ["mousemove", "mousedown", "keydown", "touchstart", "scroll", "click"];
    activityEvents.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer(); // start the timer immediately

    return () => {
      // Cleanup on unmount
      if (timerRef.current) clearTimeout(timerRef.current);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      activityEvents.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, []);
};

export default useInactivityLogout;